import { render, staticRenderFns } from "./TodasSalas.vue?vue&type=template&id=9119abce&scoped=true&"
import script from "./TodasSalas.vue?vue&type=script&lang=js&"
export * from "./TodasSalas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9119abce",
  null
  
)

export default component.exports